export const routes = {
  newAppointment: '/home/new-appointment',
  appointmentHistory: '/home/appointment-history',
  newClient: '/home/new-client',
  clientList: '/home/client-list',
  monthlyStats: '/home/monthly-stats'
};
